// One-tap JSON backup (v1 downloadBackup): every week + the full completion map.
// Photos are referenced by key, not embedded — same note v1 wrote into the file.
import { apiGet } from './api';
import { toast } from '../state/toast';

interface WeekListRes {
  default: string;
  weeks: { weekOf: string; weekId: string; count: number }[];
}

export async function downloadBackup(): Promise<void> {
  toast('Building backup…');
  try {
    const list = await apiGet<WeekListRes>('/api/schedule?list=1');
    const weekObjs = await Promise.all(
      list.weeks.map((w) => apiGet<unknown>(`/api/schedule?week=${encodeURIComponent(w.weekId)}`)),
    );
    const completions = await apiGet<unknown>('/api/completions');
    const backup = {
      exportedAt: new Date().toISOString(),
      note: 'Delta T Schedule backup. Photos are referenced by key, not embedded.',
      weeks: weekObjs,
      completions,
    };
    const blob = new Blob([JSON.stringify(backup, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `deltat-schedule-backup-${new Date().toISOString().slice(0, 10)}.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast('Backup downloaded.');
  } catch {
    toast('Backup failed — try again online.');
  }
}
